import { z } from 'zod';

/* Defensive: ClickHouse Decimal / Float64 values can come back through the
   gateway as strings to preserve precision. z.coerce.number() accepts both. */
const num = () => z.coerce.number();
const numNull = () => z.union([z.coerce.number(), z.null()]);

export const SaleStockBrandSummarySchema = z.array(
  z.object({
    week: z.string(),
    brand_name: z.string().nullable(),
    merch_portfolio: z.string().nullable(),
    brand_manager: z.string().nullable(),
    /* gross_gmv columns are optional — populated once the mesh
       fix/merch-dashboard-followup branch is applied. Until then the cube
       card omits these fields and the tab falls back to 0. */
    gross_gmv: num().optional(),
    prev_week_gross_gmv: numNull().optional(),
    three_week_avg_gross_gmv: numNull().optional(),
    net_gmv: num(),
    prev_week_net_gmv: numNull(),
    three_week_avg_net_gmv: numNull(),
    wow_pct: numNull(),
    stock: num(),
    unique_styles: num(),
    styles_3_size_ml: num(),
    three_size_ml_pct: num(),
    front_inv: num(),
    qty_sold: num(),
    /* Ledger-sourced quantities (added 2026-05-13). Optional until the mart roll
       is applied; falls back to mart_order qty_sold for return % computation. */
    gross_qty: num().optional(),
    net_qty: num().optional(),
    weekly_run_rate: numNull(),
    stock_cover_weeks: numNull(),
    rev_per_hanger: numNull(),
    prev_week_rev_per_hanger: numNull(),
    three_week_avg_rev_per_hanger: numNull(),
    avg_size_depth: num(),
    return_qty: num(),
    return_rate_pct: num(),
  }),
);
export type SaleStockBrandSummary = z.infer<typeof SaleStockBrandSummarySchema>;
